export default "__VITE_ASSET__Bpfq94Nf__"